import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {
    const {
        inputProps,
        onConfirm,
        onCancel,
        onClickPhoto,
        onHandleChange,
    } = props;
    const {type, show, price, executor, errorMsg, setimages, setvideos, shareTitle, shareText} = inputProps;

    let title = "Опубликовать результаты на сайте";
 
    let mPhotos = executor.photos && executor.photos.results || [];
    let mVideos = executor.videos && executor.videos.results || [];
    let workResults = [...mPhotos, ...mVideos];
    
    let setResults = [...setimages, ...setvideos];

    const maxLength = 5;
    const length = setResults.length;
    let otherCount = -1;
    let lastImage = false;

    if(type === 'success') title = "Опубликовано"
    if(type === 'error') title = "Произошла ошибка"

    if(length > maxLength) otherCount = length - maxLength;
   
    return (
        <SweetAlert
            show={show}
            type={type}
            customClass="sweet-alert-absolute"
            confirmBtnCssClass="alert-btn-confirm"
            cancelBtnCssClass="alert-btn-cancel"
            showCancel
            showConfirm={type === 'default' ? true : false}
            confirmBtnText="Опубликовать"
            cancelBtnText={type === 'default' ? "Отменить" : "Закрыть"}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={title}
          //  disabled={isReady ? false : true}
            onConfirm={() => onConfirm()}
            onCancel={() => onCancel()}
        >
            {
                type === 'default' ?
                <div className="sw-alert__body share-work">
                    <label className="invoice-modal__label">Выберите фото/видео для публикации:</label>

                    <ul className={"photos" + (workResults.length > 14 ? ' all-photos' : '')}>
                        {
                            workResults.map((item, index) => {
                                let type = item.image ? 'image' : 'video';
                                const selected = setResults.filter(selphoto => selphoto.id === item.id && type === selphoto.type).length;

                                return  <li className={"photos__img" + (selected ? " photo-selected" : "")} 
                                            key={index}
                                            onClick={() => onClickPhoto(item, type)}>
                                            <div className="img" style={{ backgroundImage: `url(${item.thumb_image})` }}>
                                            </div>
                                        </li>
                            })
                        }
                    </ul>

                    {
                        errorMsg && errorMsg.results ?
                        <div className="input-error-text" style={{marginTop:'-20px'}}>{errorMsg.results}</div>
                        : null
                    }

                    <div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                            <div style={{width:'50%',marginRight:'10px'}}>
                                <label className="invoice-modal__label" style={{textAlign:'left'}}>Название</label>
                                <input
                                    type='text'
                                    placeholder="Заголовок"
                                    value={shareTitle}
                                    name="shareTitle"
                                    onChange={onHandleChange}
                                    className="invoice-modal__input"
                                    style={{marginBottom:'15px'}}
                                />
                            </div>
                            <div style={{width:'50%',marginLeft:'10px'}}>
                                <label className="invoice-modal__label" style={{textAlign:'left'}}>Цена</label>
                                <input
                                    type='number'
                                    min={0}
                                    placeholder="Цена"
                                    value={price}
                                    name="price"
                                    onChange={onHandleChange}
                                    className="invoice-modal__input"
                                    style={{marginBottom:'10px'}}
                                />
                            </div>
                        </div>

                        <label className="invoice-modal__label" style={{textAlign:'left'}}>Описание</label>
                        <textarea 
                            placeholder="Описание"
                            value={shareText}
                            name="shareText"
                            onChange={onHandleChange}
                            className="invoice-modal__input"
                            style={{height: '60px',marginBottom:'15px'}}
                        />
                    </div>
                    
                </div>
                : null
            }

            {
                type === 'success' ?
                <div className="sw-alert__body">Спасибо за оценку!</div>
                : null
            }

            {/* {
                type === 'error' ?
                <div className="sw-alert__body">{errorMsg}</div>
                : null
            } */}
        </SweetAlert>
    );
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/ShareWork.js